import { useEffect, useState } from 'react'
import { POST } from 'api/request'
import * as urls from 'api/urls'

export interface Template {
  id: string
  name: string
  template: string
}

const useObituaryPreview = (
  _name: string,
  _birth: string,
  _death: string
) => {
  const [data, setData] = useState<Template[] | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchMagDetails = async (name: string, birth: string, death: string) => {
    setLoading(true)
    const body = { name, birth, death }
    const response = await POST<{ templates: Template[] }>(urls.obituaryPreview, { body })
    if (response.ok) {
      setData(response.data.templates)
    } else {
      console.error(response?.data || 'An unknown error occurred', 'error')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchMagDetails(_name, _birth, _death)
  }, [_name, _birth, _death])

  return {
    data,
    isLoading
  }
}

export default useObituaryPreview